<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1">Murder on Air Force One</p>
<p class="ORIM-Book-Subtitle--Front-Matter-">A Kate Dawson Mystery</p>
<p class="ORIM-Author-Name--Front-Matter-">John L. Flynn</p>
<div class="img_container">
<img alt="image" src="image/logo.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?63f3ac50